export default import.meta.ROLLDOWN_FILE_URL_oDTl8LRyXKJh1JPUfpzr3w